// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Benin */
const BJ = /^(?:01(?:2[5-9]|[4-69]\d)\d{6})$/;

export default BJ;
